<template>
  <div class="hero-background"></div>

  <section class="relative sm:container max-w-screen-xl mx-auto">
    <div
      class="
        flex flex-col
        items-center
        space-y-6
        lg:space-y-0 lg:flex-row lg:items-start lg:justify-around
        mt-6
      "
    >
      <div class="flex flex-col space-y-2">
        <router-link
          class="tomu-hero-button"
          :to="{ name: 'DigitalDriverCards' }"
        >
          <div class="tomu-hero-button-left-side">
            <h2 class="tomu-hero-button-title">Карты водителя</h2>
            <p class="tomu-hero-button-description">
              Описание карты водителя. СКЗИ
            </p>
          </div>
          <div
            class="tomu-hero-button-right-side"
            :style="{
              backgroundImage: cardImage,
            }"
          ></div>
        </router-link>
        <router-link
          class="tomu-hero-button"
          :to="{ name: 'VehicleRegistrationPlates' }"
        >
          <div class="tomu-hero-button-left-side">
            <h2 class="tomu-hero-button-title">Изготовление гос номеров</h2>
            <p class="tomu-hero-button-description">
              Описание изготовления гос номеров
            </p>
          </div>
          <div
            class="tomu-hero-button-right-side"
            :style="{
              backgroundImage: registrationPlatesImage,
            }"
          ></div>
        </router-link>
      </div>
      <div>
        <order-card />
      </div>
    </div>
  </section>
</template>

<script>
import cardImage from "@/assets/images/home/cards-removebg-preview-cut-0.5x.png";
import registrationPlatesImage from "@/assets/images/home/gos-nomer-rounded-1x.png";
import OrderCard from "@/components/OrderCard";

export default {
  name: "Home",
  components: {
    OrderCard,
  },
  data() {
    return {
      formData: {
        email: "",
        phoneNumber: "",
        cardType: "estr",
      },
      isValid: true,
      cardImage: `url(${cardImage})`,
      registrationPlatesImage: `url(${registrationPlatesImage})`,
    };
  },
};
</script>

<style scoped>
.hero-background {
  background-image: url(~@/assets/images/hero/combined3.svg);
  background-repeat: no-repeat;
  background-position: top center;
  background-size: contain;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

.tomu-hero-button {
  @apply bg-white rounded-md p-4 shadow-lg;

  width: 30rem;

  @apply flex;

  &-left-side {
    @apply w-3/4;
  }

  &-right-side {
    @apply w-1/4;
    @apply bg-contain bg-no-repeat bg-center;
  }

  &-title {
    @apply text-xl text-gray-700;
  }

  &-description {
    @apply text-base text-gray-500;
  }
}
</style>
